import Vue from 'vue'
import wxUtils from '@/utils/weixin/utils'

const DEFAULT_SHARE_CONFIG = {
    sun: {
        title: '和我一起参与朝阳区公民科学素质大赛吧',
        desc: '',
        imgUrl: 'http://guokrapp-static.guokr.com/Fvt31GLV613PBNxuk1E54NRNxTDN',
        link: '/quiz'
    },
    agriculture: {
        title: '2022农业生物技术科普大赛',
        desc: ' ',
        imgUrl: 'https://guokrapp-static.guokr.com/FqUb3jKSoZQxqqs7CeSDFB5QWFuO',
        link: '/quiz/agriculture'
    },
    cac: {
        title: '果壳少年科学素养测试',
        desc: '',
        imgUrl: 'http://guokrapp-static.guokr.com/FpNSY-O_ygOJjRsif-tG20ytm6U-',
        link: '/cac'
    }
}
export function share (config = {}, type = 'sun') {
    const linkPath = config.link || DEFAULT_SHARE_CONFIG[type].link
    const shareConfig = {
        ...DEFAULT_SHARE_CONFIG[type],
        ...config,
        link: linkPath ? `${location.origin}${linkPath}` : location.href
    }
    wxUtils.shareTimeline(shareConfig)
    wxUtils.shareAppMessage(shareConfig)
}

Vue.mixin({
    methods: {
        onWxShare: share,
        onHideAllNonBaseMenuItem: function () {
            wxUtils.hideAllNonBaseMenuItem()
        },
        onShowAllNonBaseMenuItem: function () {
            wxUtils.showAllNonBaseMenuItem()
        }
    }
})
